import { render, staticRenderFns } from "./modal-preview-reported-content.vue?vue&type=template&id=4b9ec54b&scoped=true&lang=pug"
import script from "./modal-preview-reported-content.js?vue&type=script&lang=js&external"
export * from "./modal-preview-reported-content.js?vue&type=script&lang=js&external"
import style0 from "./modal-preview-reported-content.vue?vue&type=style&index=0&id=4b9ec54b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9ec54b",
  null
  
)

export default component.exports